<template>
  <div class="main-layout">
    <div class="layout-content">
      <u-table
        :headers="headers"
        :items="items"
        :mobileBreakpoint="1160"
        :showSelect="false"
        :loading="loading"
        :pagination="pagination"
        itemKey="id"
        @onChangePagination="onChangePagination"
        @dbclickRow="$emit('dbclickRow',$event)"
      >
        <template v-slot:header>
          <v-row justify="end" class="header-custom-table">
            <!-- <v-col cols="4" lg="2" md="2">
              <v-select
                v-model="result"
                :items="itemResult"
                item-text="text"
                item-value="val"
                placeholder="ผลลัพธ์"
                label="ผลลัพธ์"
                :rules="[Rule.noInPut]"
                required
                outlined
                dense
                hide-details
              >
              </v-select>
            </v-col> -->
            <v-col cols="6" lg="2" md="2">
              <v-text-field
                v-model="k"
                name="name"
                outlined
                dense
                append-icon="mdi-magnify"
                placeholder="ค้นหา"
                label="ค้นหา"
                hide-details
                @keyup.enter="init()"
              >
              </v-text-field>
            </v-col>
            <v-col cols="6" lg="2" md="2">
              <v-btn color="primary" block dark @click="$emit('onSearch')"
                >ค้นหา</v-btn
              >
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`item.number`]="{ item }">
          {{
            pagination.row * pagination.page -
            pagination.row +
            (items.indexOf(item) + 1)
          }}
        </template>
        <template v-slot:[`item.create_date`]="{ item }">
          {{ item.create_date | BE_DD_MM_YYYY }}
        </template>

        <template v-slot:[`item.resource.da`]="{ item }">
          <span v-if="item.resource.da != ''">{{
            item.resource.da | BE_DD_MM_YYYY
          }}</span>
          <span v-else>-</span>
        </template>

        <template v-slot:[`item.resource.pn`]="{ item }">
          <span class="fix-overflow-ellipsis">
            {{ item.resource.pn != "" ? item.resource.pn : "-" }}
          </span>
        </template>

        <template v-slot:[`item.resource.po`]="{ item }">
          <span class="fix-overflow-ellipsis">
            {{ item.resource.po != "" ? item.resource.po : "-" }}
          </span>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            outlined
            small
            :color="colorStatusChip(item.status)"
            class="my-1"
          >
            {{ textStatusChip(item.status) }}
          </v-chip>
          <!-- <loadingEllipsis></loadingEllipsis> -->
        </template>

        <template v-slot:[`item.result`]="{ item }">
          <v-chip
            v-if="!item.status"
            outlined
            small
            :color="colorStatusChip(item.status)"
            class="my-1"
          >
            {{ textStatusChip(item.status) }}
          </v-chip>
          <div v-if="item.status">
            <div v-for="data in item.processes" :key="data.process_id">
              <v-chip
                v-if="data.results.length !== 0"
                small
                color="warning"
                class="my-1"
              >
                {{ data.name }}
              </v-chip>
            </div>
            <v-chip
              v-if="statusNormal(item.processes)"
              small
              color="success"
              class="my-1"
            >
              ไม่พบโรค
            </v-chip>
          </div>
        </template>

        <template v-slot:[`item.detail`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                icon
                fab
                x-small
                dark
                color="primary"
                @click="$emit('dbclickRow',item)"
              >
                <v-icon>mdi-clipboard-text</v-icon>
              </v-btn>
            </template>
            <span>ดูรายละเอียดทั้งหมด</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.actions`]="{}">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                icon
                fab
                x-small
                color="primary"
                disabled
              >
                <v-icon>mdi-file-download</v-icon>
              </v-btn>
            </template>
            <span>ดาวน์โหลด</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                icon
                fab
                x-small
                color="third"
                disabled
              >
                <v-icon>mdi-printer</v-icon>
              </v-btn>
            </template>
            <span>ปริ้น</span>
          </v-tooltip>
          <v-tooltip top v-if="priorityUser === 0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                icon
                fab
                x-small
                disabled
                color="error"
              >
                <v-icon>mdi-delete-forever</v-icon>
              </v-btn>
            </template>
            <span>ลบ</span>
          </v-tooltip>
        </template>

        <template v-slot:[`item.review`]="{ item }">
          <v-chip
            outlined
            small
            :color="
              returnStatusWriteReview(item.reviews) == false
                ? 'warning'
                : 'primary'
            "
            class="my-1"
          >
            {{
              returnStatusWriteReview(item.reviews) == false
                ? "ยังไม่เขียน"
                : "เขียนแล้ว"
            }}
          </v-chip>
        </template>
      </u-table>
    </div>

    <u-card-form
      :title="formTitle"
      :subtitle="formSubTitle"
      icon="mdi-clipboard-text"
      widthDialog="1000"
      ref="form"
      v-model="dialog"
    >
      <template v-slot:form>
        <div class="d-flex pb-3">
          <div class="title-card">
            H/N :
            {{ detailItem.resource.po != "" ? detailItem.resource.po : "-" }}
          </div>
          <v-spacer></v-spacer>
          <!-- <div class="title-card">สถานะ :</div> -->
        </div>
        <div class="detal-card pb-3">
          ชื่อผู้ป่วย :
          {{ detailItem.resource.pn != "" ? detailItem.resource.pn : "-" }}
        </div>
        <div class="detal-card pb-3">
          วันที่อัปโหลด :
          {{
            $moment(detailItem.start_date).add(543, "year").format("DD-MM-YYYY")
          }}
        </div>
        <div class="detal-card pb-3">
          วันที่ X-ray :
          {{
            detailItem.resource.da != ""
              ? $moment(detailItem.resource.da)
                  .add(543, "year")
                  .format("DD-MM-YYYY")
              : "-"
          }}
        </div>
        <div class="detal-card pb-3">
          ชื่อไฟล์ : {{ detailItem.resource.filename }}
        </div>
        <div class="detal-card pb-3">
          consult : {{ returnConsult(consultJob) }}
          <!-- <span v-for="(dataConsult, i) in consultJob" :key="i"
              >{{ dataConsult.first_name }} {{ dataConsult.last_name
              }}<span v-if="i + 1 !== consultJob.length">, </span></span
            > -->
        </div>
        <v-btn
          @click="openFormConsoult()"
          small
          :dark="detailItem.status"
          color="primary"
          :disabled="!detailItem.status"
          ><v-icon class="mr-2">mdi-note-edit</v-icon>ส่งconsult</v-btn
        >
        <div style="display: flex" class="mb-n3 mt-4">
          <div class="detal-card mr-1">โรคที่พบ :</div>
          <div>
            <v-radio-group v-model="disease" row class="layout-radio">
              <v-radio
                v-for="items in detailItem.processes"
                :key="items.process_id"
                :label="items.name"
                :value="items"
                class=""
              ></v-radio>
            </v-radio-group>
          </div>
        </div>
        <v-divider class="mb-5"></v-divider>
        <div
          style="display: flex"
          v-if="
            disease.results !== null &&
            disease.results !== undefined &&
            disease.results.length !== 0
          "
        >
          <div class="">*เลือกกล่องที่ต้องการดูผล :</div>
          <div style="display: flex; flex-wrap: wrap">
            <div
              v-for="item in disease.results"
              :key="item.result_id"
              style="width: fit-content"
              class="mx-2"
            >
              <v-checkbox
                v-model="checkBoxDisease[item.name]"
                :label="`confident : ${item.confident}%`"
                :value="item"
                class="pa-0 ma-0"
              ></v-checkbox>
            </div>
          </div>
        </div>

        <v-alert text dense :color="colorIconStatus" border="left">
          {{ disease.status }}
        </v-alert>
        <div
          v-if="
            disease.results !== null &&
            disease.results !== undefined &&
            disease.results.length !== 0
          "
        >
          <squareOnImage
            :box="checkBoxDisease[disease.name]"
            :srcImage="detailItem.resource.file"
          />
        </div>
        <div
          v-if="disease.results !== undefined && disease.results.length === 0"
        >
          <v-img :src="detailItem.resource.file"></v-img>
        </div>
        <div class="detal-card mt-5">
          <div class="primary--text mb-3">เขียนข้อเสนอแนะ</div>
          <div>
            <u>{{ userInfo.first_name }} {{ userInfo.last_name }}</u>
          </div>
          <v-textarea
            v-model="review"
            auto-grow
            outlined
            rows="5"
            row-height="15"
            class="mt-3 mb-n3"
            :disabled="disabledReview"
          ></v-textarea>
          <div class="mb-5 d-flex">
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!detailItem.status"
              :dark="detailItem.status"
              color="primary"
              v-if="disabledReview"
              @click="(disabledReview = false), (reviewOld = review)"
            >
              {{
                ststusReview === "add" ? "เขียนข้อเสนอแนะ" : "แก้ไขข้อเสนอแนะ"
              }}
            </v-btn>
            <v-btn
              :disabled="!detailItem.status"
              :dark="detailItem.status"
              :loading="loading"
              class="mx-1"
              color="primary"
              v-if="!disabledReview"
              @click="updateReview()"
            >
              บันทึก
            </v-btn>
            <v-btn
              :disabled="!detailItem.status"
              :dark="detailItem.status"
              :loading="loading"
              color="error"
              v-if="!disabledReview"
              @click="closeUpdateReview()"
            >
              ยกเลิก
            </v-btn>
          </div>
        </div>
        <v-divider class="mb-5"></v-divider>
        <div class="detal-card">
          <div class="my-5">ข้อเสนอแนะอื่น</div>
          <div
            v-if="detailItem.reviews.length === 1 && ststusReview === 'edit'"
          >
            -
          </div>
          <div v-if="detailItem.reviews.length === 0">-</div>
          <div v-for="item in detailItem.reviews" :key="item.review_id">
            <div v-if="item.create_by !== userInfo.user_id">
              <u>
                <span>{{ item.first_name }} {{ item.last_name }}</span>
                <span v-if="item.first_name === '' && item.last_name === ''"
                  >Unknow</span
                >
                <span v-if="item.type === 'consult'"> : consult</span></u
              >
              <v-textarea
                :value="
                  item.description !== ''
                    ? item.description
                    : 'ยังไม่เขียนข้อเสนอแนะ'
                "
                auto-grow
                outlined
                rows="5"
                row-height="15"
                class="mt-3"
                disabled
              ></v-textarea>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:actions="{}">
        <v-row>
          <v-col
            ><v-btn :loading="loading" block color="error" @click="close"
              >ปิด</v-btn
            ></v-col
          >
        </v-row>
      </template>
    </u-card-form>

    <u-card-form
      title="ส่งconsult"
      subtitle=""
      icon="mdi-note-edit"
      widthDialog="500"
      v-model="dialogConsult"
    >
      <template v-slot:form>
        <div><span>เลือกผู้ที่ต้องการส่งให้ consult</span></div>
        <v-select
          v-model="consult"
          :items="itemConsult"
          :item-text="(item) => item.first_name + ' ' + item.last_name"
          item-value="user_id"
          placeholder="กรุณาเลือกผู้ที่ต้องการส่งให้ consult"
          :loading="loading"
          chips
          dense
          multiple
          outlined
        >
          <template v-slot:selection="{ item, index }">
            <v-chip v-if="index <= 1">
              <span>{{ item.first_name }} {{ item.last_name }}</span>
            </v-chip>
            <span v-if="index === 2" class="grey--text text-caption">
              (+{{ consult.length - 2 }} others)
            </span>
          </template>
        </v-select>
      </template>
      <template v-slot:actions="{}">
        <v-row>
          <v-col>
            <v-btn
              block
              color="primary"
              :loading="loading"
              @click="UpdaeteConsult()"
            >
              บันทึก
            </v-btn>
          </v-col>
          <v-col>
            <v-btn
              block
              color="error"
              :loading="loading"
              @click="
                closeDialgConsult(), matchConsult(detailItem.users, itemConsult)
              "
            >
              ยกเลิก
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </u-card-form>
  </div>
</template>
<script>
import squareOnImage from '../squareOnImage.vue'
// import loadingEllipsis from '@/components/Loading/ellipsis.vue'

export default {
  components: {
    squareOnImage
    // loadingEllipsis
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    keyword: {
      type: String,
      default: ''
    },
    pagination: {
      type: Object,
      default: () => {
        return { total: 0, page: 1, row: 10 }
      }
    },

    hospital_id: {
      type: String
    },
    priorityUser: {
      type: Number,
      default: null
    },
    userInfo: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      refresh: false,
      loading: false,
      dialog: false,
      headers: [
        {
          text: 'ลำดับ',
          align: 'center',
          sortable: false,
          value: 'number',
          width: '70px'
        },
        {
          text: 'วัน/เวลา ที่อัปโหลด',
          value: 'create_date',
          sortable: false,
          align: 'center',
          width: '150px'
        },
        {
          text: 'วัน/เวลา X-ray',
          value: 'resource.da',
          sortable: false,
          align: 'center',
          width: '150px'
        },
        {
          text: 'ชื่อผู้ป่วย',
          align: 'start',
          sortable: false,
          value: 'resource.pn'
        },
        {
          text: 'H/N',
          align: 'start',
          value: 'resource.po',
          sortable: false,
          width: '200px'
        },
        {
          text: 'สถานะ',
          align: 'center',
          value: 'status',
          sortable: false,
          width: '150px'
        },
        {
          text: 'ผลลัพธ์',
          value: 'result',
          sortable: false,
          align: 'center'
        },
        {
          text: 'รายละเอียด',
          value: 'detail',
          sortable: false,
          align: 'center',
          width: '100px'
        }
        // {
        //   text: 'ข้อเสนอแนะ',
        //   value: 'review',
        //   sortable: false,
        //   align: 'center'
        // },
        // { text: 'จัดการ', value: 'actions', sortable: false, align: 'center' }
      ],
      // items: [],
      result: 'all',
      itemResult: [
        {
          val: 'abnormal',
          text: 'ตรวจพบ'
        },
        {
          val: 'normal',
          text: 'ปกติ'
        },
        {
          val: 'all',
          text: 'ทั้งหมด'
        }
      ],
      detailItem: {
        resource: {
          po: '',
          da: ''
        },
        processes: [],
        create_date: '',
        reviews: []
      },
      // show processes
      disease: {},
      checkBoxDisease: {},
      /// -----formConsult---------///
      consult: [],
      itemConsult: [],
      dialogConsult: false,
      consultJob: [],
      review: '',
      review_id: '',
      ststusReview: '', // update or add
      disabledReview: true,
      reviewOld: ''
    }
  },
  computed: {
    formTitle () {
      return 'รายละเอียดทั้งหมด'
    },
    formSubTitle () {
      return ''
    },
    colorIconStatus () {
      if (this.disease.status === 'pending') return 'primary'
      else if (this.disease.status === 'success') return 'success'
      else return 'red'
    },

    k: {
      // TODO สำหรับ Field Keyword
      get () {
        return this.keyword
      },
      set (val) {
        this.$emit('update:keyword', val)
        return val
      }
    },
    p: {
      // TODO สำหรับ Field Pagination
      get () {
        return this.pagination
      },
      set (val) {
        this.$emit('update:pagination', val)
        return val
      }
    }
  },

  methods: {
    // async init () {
    //   this.loading = true
    //   this.refresh = false
    //   // TODO เป็น Function ที่ใช้ในการ initial ข้อมูลที่จะเอามาใส่ในตราง
    //   const payload = {
    //     page: this.pagination.page,
    //     row: this.pagination.row,
    //     hospital_id: this.hospital_id,
    //     keyword: this.keyword,
    //     diagnosis: this.result === 'all' ? '' : this.result
    //   }
    //   const res = await this.getHistoryForTable(payload)
    //   this.loading = false
    //   if (res.status) {
    //     // this.items = res.data.data
    //     this.p = res.data.pagination
    //   } else {
    //     this.antmessage.error(res.message)
    //   }
    // },
    returnConsult (consultJob) {
      let listName = ''
      if (consultJob.length !== 0) {
        for (let index = 0; index < consultJob.length; index++) {
          listName =
            listName +
            consultJob[index].first_name +
            consultJob[index].last_name
          if (index + 1 !== consultJob.length) {
            listName = listName + ', '
          }
        }
        return listName
      } else {
        return '-'
      }
    },

    // matchConsult (users = [], consultHospital = []) {
    //   const itemConsultOnly = []
    //   const arrayConsult = []
    //   for (let index = 0; index < users.length; index++) {
    //     for (let index1 = 0; index1 < consultHospital.length; index1++) {
    //       if (users[index] === consultHospital[index1].user_id) {
    //         arrayConsult.push(users[index])
    //         itemConsultOnly.push(consultHospital[index1])
    //       }
    //     }
    //   }
    //   this.consult = arrayConsult
    //   this.consultJob = itemConsultOnly
    // },
    // returnStatusWriteReview (reviews) {
    //   let status = false
    //   for (let index = 0; index < reviews.length; index++) {
    //     if (reviews[index].description !== '') {
    //       status = true
    //     }
    //   }
    //   return status
    // },
    // closeUpdateReview () {
    //   this.$swal({
    //     allowEnterKey: false,
    //     title: 'ยกเลิกการเขียนข้อเสนอแนะ',
    //     text: 'คุณต้องการยกเลิกการเขียนข้อเสนอแนะนี้ใช่หรือไม่',
    //     icon: 'warning',
    //     showCancelButton: true,
    //     cancelButtonText: 'ยกเลิก',
    //     confirmButtonText: 'ตกลง'
    //   }).then(async (result) => {
    //     if (result.isConfirmed) {
    //       this.disabledReview = true
    //       this.review = this.reviewOld
    //     }
    //   })
    // },
    // setReview (itemReview) {
    //   let status = 'add'
    //   for (let index = 0; index < itemReview.length; index++) {
    //     if (itemReview[index].create_by === this.userInfo.user_id) {
    //       status = 'edit'
    //       this.review = itemReview[index].description
    //       this.review_id = itemReview[index].review_id
    //     }
    //   }
    //   this.ststusReview = status
    // },
    // updateReview () {
    //   this.$swal({
    //     allowEnterKey: false,
    //     title: 'เขียนข้อเสนอแนะ',
    //     text: 'คุณต้องการบันทึกข้อเสนอแนะนี้ใช่หรือไม่',
    //     icon: 'warning',
    //     showCancelButton: true,
    //     cancelButtonText: 'ยกเลิก',
    //     confirmButtonText: 'ตกลง'
    //   }).then(async (result) => {
    //     if (result.isConfirmed) {
    //       if (this.ststusReview === 'add') {
    //         this.loading = true
    //         const payload = {
    //           job_id: this.detailItem.job_id,
    //           description: this.review
    //         }
    //         const res = await this.createHistoryReview(payload)
    //         this.loading = false
    //         if (res.status) {
    //           this.$swal({
    //             allowEnterKey: false,
    //             title: 'สำเร็จ',
    //             text: 'บันทึกข้อเสนอแนะสำเร็จ',
    //             icon: 'success',
    //             showConfirmButton: false,
    //             showCancelButton: false,
    //             timer: 3000
    //           })
    //           this.init()
    //           this.disabledReview = true
    //           this.close()
    //         } else {
    //           this.antmessage.error(res.message)
    //         }
    //       } else if (this.ststusReview === 'edit') {
    //         this.loading = true
    //         const payload = {
    //           job_id: this.detailItem.job_id,
    //           review_id: this.review_id,
    //           description: this.review
    //         }
    //         const res = await this.updaeteHistoryReview(payload)
    //         this.loading = false
    //         if (res.status) {
    //           this.$swal({
    //             allowEnterKey: false,
    //             title: 'สำเร็จ',
    //             text: 'บันทึกข้อเสนอแนะสำเร็จ',
    //             icon: 'success',
    //             showConfirmButton: false,
    //             showCancelButton: false,
    //             timer: 3000
    //           })
    //           this.init()
    //           this.disabledReview = true
    //           this.close()
    //         } else {
    //           this.antmessage.error(res.message)
    //         }
    //       }
    //     }
    //   })
    // },
    // UpdaeteConsult () {
    //   this.$swal({
    //     allowEnterKey: false,
    //     title: 'ส่งconsult',
    //     text: 'คุณต้องการแก้ไขรายชื่อที่ส่ง consult ใช่หรือไม่',
    //     icon: 'warning',
    //     showCancelButton: true,
    //     cancelButtonText: 'ยกเลิก',
    //     confirmButtonText: 'ตกลง'
    //   }).then(async (result) => {
    //     if (result.isConfirmed) {
    //       this.loading = true
    //       const payload = {
    //         hospital_id: this.hospital_id,
    //         job_id: this.detailItem.job_id,
    //         user_id: this.consult
    //       }
    //       const res = await this.updaeteConsult(payload)
    //       this.loading = false
    //       if (res.status) {
    //         this.$swal({
    //           allowEnterKey: false,
    //           title: 'สำเร็จ',
    //           text: 'แก้ไขรายชื่อที่ส่ง consult สำเร็จ',
    //           icon: 'success',
    //           showConfirmButton: false,
    //           showCancelButton: false,
    //           timer: 3000
    //         })
    //         // ต้องแก้
    //         this.init()
    //         this.closeDialgConsult()
    //         this.close()
    //       } else {
    //         this.antmessage.error(res.message)
    //       }
    //     }
    //   })
    // },
    // closeDialgConsult () {
    //   this.dialogConsult = false
    // },
    // async initItemConsult () {
    //   this.loading = true
    //   const payload = {
    //     hospital_id: this.hospital_id,
    //     tag_name: 'consult'
    //   }
    //   const res = await this.getItemConsult(payload)
    //   this.loading = false
    //   if (res.status) {
    //     this.itemConsult = res.data
    //   } else {
    //     this.antmessage.error(res.message)
    //   }
    // },
    // openFormConsoult () {
    //   this.dialogConsult = true
    // },
    statusNormal (processes) {
      let status = true
      for (let index = 0; index < processes.length; index++) {
        if (processes[index].results.length !== 0) {
          status = false
        }
      }
      return status
    },
    colorStatusChip (status) {
      return status === true ? 'success' : 'primary'
    },
    textStatusChip (status) {
      return status === true ? 'สำเร็จ' : 'กำลังดำเนินการ'
    },

    onChangePagination (val) {
      this.p.page = val.page
      this.p.row = val.row
      this.$emit('onChangePagination')
      // this.init()
    },
    // async detailAll (item) {
    //   this.disabledReview = true
    //   this.consult = []
    //   this.itemConsult = []
    //   await this.initItemConsult()
    //   this.detailItem = await Object.assign({}, item)

    //   // set box image
    //   this.checkBoxDisease = await Object.assign({}, {})
    //   const checkBox = {}
    //   for (let index = 0; index < this.detailItem.processes.length; index++) {
    //     if (this.detailItem.processes[index].results.length !== 0) {
    //       checkBox[this.detailItem.processes[index].name] = [
    //         this.detailItem.processes[index].results[0]
    //       ]
    //     } else {
    //       checkBox[this.detailItem.processes[index].name] = []
    //     }
    //   }

    //   this.checkBoxDisease = Object.assign({}, checkBox)
    //   this.disease = await this.detailItem.processes[0]

    //   // ----match user consult
    //   this.matchConsult(this.detailItem.users, this.itemConsult)
    //   // set review edit or add
    //   this.setReview(this.detailItem.reviews)
    //   this.dialog = true
    // },

    close () {
      // this.$refs.form.reset()
      // this.$refs.form.resetValidation()
      this.review = ''
      this.dialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      this.disease = {}
      this.checkBoxDisease = {}
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-radio {
  margin-top: 0px !important;
  padding-top: 0px !important;
}
.title-card {
  font-size: 20px;
  font-weight: 300;
}
.detal-card {
  font-size: 18px;
  font-weight: 300;
}
.main-layout {
  height: 100%;
}
.layout-content {
  height: 100%;
  padding: 0;
  margin: 0;
}
html.swal2-shown,
body.swal2-shown {
  overflow-y: hidden !important;
  height: auto !important;
}
</style>
